// @flow strict

import * as React from 'react';
import PageContentBlock from '../../../../internal/PageContentBlock';
import { ExpanderBase } from '../../../../components/Expander';
import Address from '../../../../internal/Address';
import { Link } from '../../../../internal/Button';
import type { AddressType } from '../../../../internal/Address';
import { Columns } from '../../../../internal/Columns';

export type PropTypes = {|
  officeIntro: string,
  offices: Array<{|
    name: string,
    address: AddressType,
    phone: string,
  |}>,
|};

export default (props: PropTypes) => {
  if (props.offices.length === 0) {
    return null;
  }

  return (
    <PageContentBlock title="Office locations" intro={props.officeIntro}>
      <Columns columns={3} spacing="Small">
        {props.offices.map((office, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <ExpanderBase title={office.name} key={index}>
            <address itemScope itemType="http://schema.org/Organization">
              <Address address={office.address} />
              <Link href={`tel: ${office.phone}`} itemProp="telephone" variant="Link">
                {office.phone}
              </Link>
            </address>
          </ExpanderBase>
        ))}
      </Columns>
    </PageContentBlock>
  );
};
